export const KEY_IS_EDITOR = 'is_editor_ref';
export const KEY_STEP_TEXT = 'customize_next_step_text';
export const KEY_CURRENT_NAME = 'customize_name_text';
export const KEY_CURRENT_PRICE = 'customize_price_text';
export const KEY_CURRENT_STEP = 'customize_step_text';
